import { DashboardWidgetData } from 'features/widget/types'
import { AnnotatedMetricResult } from 'schemas/AnnotatedMetricResultSchema'
import { MetricSeries } from 'schemas/MetricSeriesSchema'
import ReturnStatus from 'enums/ReturnStatus'

export const isDatasetLanguageNotSupported = (dataset?: MetricSeries[]) => {
  if (!dataset || dataset.length === 0) {
    return false
  }

  return (
    dataset.find((series) => series.status === ReturnStatus.LANGUAGE_NOT_SUPPORTED) !== undefined
  )
}

export const languageNotSupported = (entry: DashboardWidgetData<AnnotatedMetricResult>) =>
  isDatasetLanguageNotSupported(entry.results![0].data.metrics![0].dataset)
